import api from '@/apis/pa/pASalaryAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('pASalary', api);

const state = {
  ...crud.state,
  _config: {
    table: 'pa_salary',
    field: {
      key: 'ref_id',
    },
  },
  dataLayoutTemplates: [],
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  updateDataLayoutTemplates(context, data) {
    context.commit('setDataLayoutTemplates', data);
  },
};
const mutations = {
  ...crud.mutations,

  setDataLayoutTemplates(state, data) {
    state.dataLayoutTemplates = data;
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
